module.exports = __webpack_public_path__ + "img/logo2.5eb13524.png";